var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Header'),_c('Carousel'),_c('section',{staticClass:"container"},[_c('SearchComponent',{staticClass:"searchcomponent"}),(_vm.postLoaded)?_c('ImageCards',{attrs:{"cards":_vm.volunteerTags}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }